module.exports = __webpack_public_path__ + "img/activityIcon.7352149.png";